export const orderBasedInitial = {
  orderValue: "",
  reward: 0,
};
export const visitBasedInitial = {
  rewardPerVisit: 0,
};
export const feedbackBasedInitial = {
  rewardPerFeedback: 0,
};
export const handleOrderSubmit = (
  event,
  setFunction,
  setObject,
  fields,
  setFields
) => {
  event.preventDefault();
  var newObject = {};
  if (setObject["order_based_rewards"]) {
    const tempObject = setObject["order_based_rewards"];
    var count = 1;
    Object.keys(tempObject).map((index) => {
      newObject = { ...newObject, [count]: tempObject[index] };
      count++;
    });
    newObject = { ...newObject, [count]: fields };
  } else {
    newObject = { 1: fields };
  }
  const name = "order_based_rewards";
  setFunction({ ...setObject, [name]: newObject });
  setFields(orderBasedInitial);
};
export const handleChange = (event, setFunction, fields) => {
  const { value, name } = event.target;
  setFunction({ ...fields, [name]: value });
};
